//正常浏览器定位api
var config = require("../config");

var supportGeo = function () {
    return !!navigator.geolocation;
};


module.exports = function (suc, fail, next) {
    if (!supportGeo()) {
        next();
    } else {
        navigator.geolocation.getCurrentPosition(function (crd) {
            suc({
                lat: crd.coords.latitude,
                lng: crd.coords.longitude
            });
        }, function (e) {
            if (e) {
                fail({
                    code: e.code,
                    message: e.message
                });
            }else{
                fail({
                    message:"unknown error"
                });
            }
        }, {
            enableHighAccuracy: true,
            maximumAge: 30000,
            timeout: config.get("timeout") || 100000
        });
    }
};

module.exports.type = "html";


// WEBPACK FOOTER //
// ./~/@dp/whereami/lib/geos/html.js